<template>
  <div class="home overflow-hidden">
    <AboutUsHero />
    <AboutThreeCard />
    <ProfileHero />
  </div>
</template>

<script>
import AboutUsHero from '../components/elements/AboutUsHero.vue'
import AboutThreeCard from '../components/elements/AboutThreeCard.vue'
import ProfileHero from '../components/elements/ProfileHero.vue'
export default {
  name: 'About',
  metaInfo: {
    title: 'About'
  },
  components: {
    AboutUsHero,
    AboutThreeCard,
    ProfileHero
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
p {
  color: red;
  font-size: 20px;
}

.jotform-form {
  margin-top: .clampedW(7, @md-bp, @large-bp) [ @result];
  margin-bottom: .clampedW(4, @md-bp, @large-bp) [ @result];
  flex: 0 1 .clampedWrem(50, @md-bp, @large-bp) [ @result];
  .form-textbox {
    -webkiit-appearance: none;
    border: .clampedW(0.3, @md-bp, @large-bp) [ @result] solid #f58220;
    border-radius: 0;
    margin: 0;
    background-color: #fff;
    //padding:.clampedW(1, @md-bp, @large-bp) [ @result] .clampedW(1.5, @md-bp, @large-bp) [ @result];
    padding: 1rem 1.5rem;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
  }
  .button {
    display: inline-flex;
    background-color: #f58220;
    padding: .clampedWrem(3, @md-bp, @large-bp) [ @result]
      .clampedWrem(4.8, @md-bp, @large-bp) [ @result];
    margin: 0;
    font-size: .clampedWrem(2.4, @md-bp, @large-bp) [ @result];
    color: white;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
    font-weight: 700;
    text-align: center;
  }
}
</style>
